// ProfileDisplay.js
import React, { useEffect, useState } from 'react';
import './ProfileDisplay.css'; // We will create this file next

/**
 * A helper component to render a single report type (advanced, dynamic, compact)
 */
const ReportSection = ({ reportData, selectedReportLanguageCode }) => {
  if (!reportData) {
    return <div className="report-section-empty">No data for this view.</div>;
  }

  const { about, tips } = reportData;

  // A helper to get the first available language from a text object
  const getDisplayText = (textObj) => {
    if (!textObj) return "";
    if (textObj[selectedReportLanguageCode]) {
      console.log("this is textObj[selectedReportLanguageCode]", textObj, selectedReportLanguageCode, textObj[selectedReportLanguageCode]);
      
      return textObj[selectedReportLanguageCode];
    } else {
      return textObj.en;
    }
    // Fallback to the first available language
    // return Object.values(textObj)[0] || "";
  };

  return (
    <div className="report-section">
      {/* --- About Section --- */}
      {about && (
        <div className="about-card">
          <h3>{getDisplayText(about.header)}</h3>
          <p dangerouslySetInnerHTML={{ __html: getDisplayText(about.text) }} />
        </div>
      )}

      {/* --- Tips Sections --- */}
      {tips && tips.length > 0 && (
        <div className="tips-container">
          {tips.map((tipGroup, index) => (
            <div key={index} className="tip-group-card">
              {/* Tip Group Header (if it exists) */}
              {getDisplayText(tipGroup.header) && (
                <h4 className="tip-group-header">
                  {getDisplayText(tipGroup.header)}
                </h4>
              )}
              
              {/* Tip Group SubHeader (if it exists) */}
              {getDisplayText(tipGroup.subHeader) && (
                <p className="tip-group-subheader">
                  {getDisplayText(tipGroup.subHeader)}
                </p>
              )}

              {/* List of Tips */}
              <ul className="tips-list">
                {tipGroup.tipsArray.map((tip, tipIndex) => (
                  <li key={tipIndex} className="tip-item">
                    {tip.svg && (
                      <img 
                        src={`https://reportsvg.s3.ap-south-1.amazonaws.com/reportSvg/pfh/svg/${tip.svg}`} // Assuming icons are in /public/icons
                        alt="tip icon" 
                        className="tip-icon" 
                      />
                    )}
                    <p dangerouslySetInnerHTML={{ __html: getDisplayText(tip.text) }} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

/**
 * Main component to display the selected profile with tabs
 */
const ProfileDisplay = ({ profileData, selectedReportType, selectedReportLanguageCode }) => {
  const [activeTab, setActiveTab] = useState(selectedReportType.toLowerCase());  

  const reportViews = {
    advanced: profileData.advanced,
    dynamic: profileData.dynamic,
    compact: profileData.compact,
  };

  if (!profileData) {
    return <div>No profile data selected.</div>;
  }

  return (
    <div className="profile-display-container">
      <div className="profile-tabs">
        <button
          className={activeTab === 'advanced' ? 'active' : ''}
          onClick={() => setActiveTab('advanced')}
        >
          Total
        </button>
        <button
          className={activeTab === 'dynamic' ? 'active' : ''}
          onClick={() => setActiveTab('dynamic')}
        >
          Personal
        </button>
        <button
          className={activeTab === 'compact' ? 'active' : ''}
          onClick={() => setActiveTab('compact')}
        >
          Compact
        </button>
      </div>

      <div className="profile-content">
        <ReportSection reportData={reportViews[activeTab]} selectedReportLanguageCode={selectedReportLanguageCode} />
      </div>
    </div>
  );
};

export default ProfileDisplay;